import {
  ClearRedirectUrlAction,
  SFDCAuthActions,
  SFDCAuthState,
  SetInitializedAction,
  SetContactIdAction,
  SetIsRoasterAdminAction,
  SetProfileNameAction,
  SetRedirectUrlAction,
  SetRoleAction,
  SetSFDCAuthLoadingAction,
  SetSFDCAuthTokensAction,
  sfdcLocalStorageKeys,
} from "./types";

export const initialState: SFDCAuthState = {
  initialized: false,
  loading: false,
  sfdcAuthToken: null,
  sfdcIdToken: null,
  sfdcRefreshToken: null,
  redirectUrl: null,
  isRoasterAdmin: false,
  role: null,
  profileName: null,
  contactId: null,
};

export const setInitialized = (): SetInitializedAction => ({
  type: "SET_INITIALIZED",
});

export const setAuthLoading = (loading: boolean): SetSFDCAuthLoadingAction => ({
  type: "SET_SFDC_AUTH_LOADING",
  payload: loading,
});

export const setSFDCAuthTokens = (
  sfdcAuthToken: SFDCAuthState["sfdcAuthToken"],
  sfdcIdToken: SFDCAuthState["sfdcIdToken"],
  sfdcRefreshToken: SFDCAuthState["sfdcRefreshToken"]
): SetSFDCAuthTokensAction => ({
  type: "SET_SFDC_AUTH_TOKENS",
  payload: {
    sfdcAuthToken,
    sfdcIdToken,
    sfdcRefreshToken,
  },
});

export const setIsRoasterAdmin = (isRoasterAdmin: boolean): SetIsRoasterAdminAction => ({
  type: "SET_IS_ROASTER_ADMIN",
  payload: isRoasterAdmin,
});
export const setRole = (role: SFDCAuthState["role"]): SetRoleAction => ({
  type: "SET_ROLE",
  payload: role,
});

export const setProfileName = (profileName: SFDCAuthState["profileName"]): SetProfileNameAction => ({
  type: "SET_PROFILE_NAME",
  payload: profileName,
});

export const setContactId = (contactId: SFDCAuthState["contactId"]): SetContactIdAction => ({
  type: "SET_CONTACT_ID",
  payload: contactId,
});

export const setRedirectUrl = (url: string): SetRedirectUrlAction => ({
  type: "SET_REDIRECT_URL",
  payload: url,
});

export const clearRedirectUrl = (): ClearRedirectUrlAction => ({
  type: "CLEAR_REDIRECT_URL",
});

export const reducer = (state: SFDCAuthState, action: SFDCAuthActions): SFDCAuthState => {
  switch (action.type) {
    case "SET_INITIALIZED":
      return { ...state, initialized: true };
    case "SET_SFDC_AUTH_LOADING":
      return { ...state, loading: action.payload };
    case "SET_SFDC_AUTH_TOKENS": {
      const { sfdcAuthToken, sfdcIdToken, sfdcRefreshToken } = action.payload;
      handleLocalStorage(sfdcLocalStorageKeys.sfdcAuthToken, sfdcAuthToken);
      handleLocalStorage(sfdcLocalStorageKeys.sfdcIdToken, sfdcIdToken);
      handleLocalStorage(sfdcLocalStorageKeys.sfdcRefreshToken, sfdcRefreshToken);

      return {
        ...state,
        sfdcAuthToken: action.payload.sfdcAuthToken,
        sfdcIdToken: action.payload.sfdcIdToken,
        sfdcRefreshToken: action.payload.sfdcRefreshToken,
      };
    }
    case "SET_IS_ROASTER_ADMIN":
      if (action.payload) {
        setLocalStorageFlag(sfdcLocalStorageKeys.sfdcIsRoasterAdmin);
      } else {
        removeLocalStorageFlag(sfdcLocalStorageKeys.sfdcIsRoasterAdmin);
      }
      return { ...state, isRoasterAdmin: action.payload };
    case "SET_ROLE":
      handleLocalStorage(sfdcLocalStorageKeys.role, action.payload);
      return { ...state, role: action.payload };
    case "SET_PROFILE_NAME":
      handleLocalStorage(sfdcLocalStorageKeys.profileName, action.payload);
      return { ...state, profileName: action.payload };
    case "SET_CONTACT_ID":
      handleLocalStorage(sfdcLocalStorageKeys.contactId, action.payload);
      return { ...state, contactId: action.payload };
    case "SET_REDIRECT_URL":
      localStorage.setItem("redirectUrl", action.payload);
      return { ...state, redirectUrl: action.payload };
    case "CLEAR_REDIRECT_URL":
      localStorage.removeItem("redirectUrl");
      return { ...state, redirectUrl: null };
    default:
      return state;
  }
};

export const handleLocalStorage = (key: string, value?: string | null) => {
  if (value) {
    localStorage.setItem(key, value);
  } else {
    localStorage.removeItem(key);
  }
};

export const setLocalStorageFlag = (key: string) => {
  localStorage.setItem(key, "true");
};

export const removeLocalStorageFlag = (key: string) => {
  localStorage.removeItem(key);
};
